import $ from 'jquery'
import tinycolor from 'tinycolor2'

import colors from '../../lib/colors'

import { icon as iconComponent } from '../../component/component'

export default function(text,icon,disabled,color){

  if(!color){
    color = colors.white
  }

  var div =
    $('<div>')
    .css({
      padding: '8px',
      cursor: 'pointer',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      height: '34px',
      display: 'inline-block',
    })
    .hover(
      function(){
        if(!disabled){
          $(this).css({
            background: colors.black,
          });
        };
      },
      function(){
        if(!disabled){
          $(this).css({
            background: colors.grey.s_900,
          });
        };
      }
    )

  if(icon){
    var iconElement =
      iconComponent(icon,color)
      .css({
        display: 'inline-block',
        verticalAlign: '-5px',
        width: '18px',
        height: '18px',
      });
    div.append(iconElement)
  }

  if(text){
    div.append(text)
    if(icon){
      iconElement.css({
        marginRight: '4px',
      });
    }
  }

  if(icon && !text){
    div.css({
      width: '34px',
      textAlign: 'center',
    })
  }

  var setColor = function(c){
    if(c){
      color = c
    }
    if(text){
      div.css({
        color: color,
      })
    }
    if(icon){
      iconElement.setColor(color)
    }
  }

  var setIcon = function(i){
    icon = i
    iconElement.setIcon(i)
  }

  var setDisabled = function(value){
    if(value){
      disabled = value
      div.css({
        cursor: 'default',
        background: colors.black,
      })
    } else {
      disabled = value
      div.css({
        cursor: 'pointer',
        background: colors.grey.s_900,
      })
    }
  }

  var getDisabled = function(value){
    return disabled
  }

  setColor(color)
  setDisabled(disabled)

  div.setColor = setColor
  div.setIcon = setIcon
  div.setDisabled = setDisabled
  div.getDisabled = getDisabled

  return div;

}



// WEBPACK FOOTER //
// ./src/client/component/button/button.js